// extracted by mini-css-extract-plugin
module.exports = {"terms":"FiberInterestForm_terms__jqfUF"};